import React from 'react';
import styled from 'styled-components';
import { Trans } from 'react-i18next';

import useConfirmDialog from 'hooks/useConfirmDialog';
import Button from 'components/button';
import { UserContext } from '../../../../state';
import { continueLeaseApplication } from './common';

export const LaunchAppButton = ({ className, showing, navigate }) => {
  const [loading, setLoading] = React.useState(false);
  const { userContext } = React.useContext(UserContext);
  const confirmDialog = useConfirmDialog();

  const clickEvent = () => {
    if (loading) return;
    setLoading(true);
    continueLeaseApplication({
      confirmDialog,
      userContext,
      showing,
      existingApplications: showing.existingLeaseApplications,
      navigate,
      onFinished: () => setLoading(false)
    });
  };

  const { title, titleTrans, buttonTrans, buttonText } = React.useMemo(() => {
    if (showing.existingLeaseApplications?.length > 0) {
      return {
        title: 'You have an application in progress',
        titleTrans: 'showing.actions.continueLeaseApplicationTitle',
        buttonText: 'Continue Lease Application →',
        buttonTrans: 'showing.actions.continueLeaseApplication'
      };
    } else {
      return {
        title: 'Ready to apply for this home?',
        titleTrans: 'showing.actions.startLeaseApplicationTitle',
        buttonText: 'Start Lease Application',
        buttonTrans: 'showing.actions.startLeaseApplication'
      };
    }
  }, [showing.existingLeaseApplications?.length]);

  return (
    <ActionRow className={className}>
      <span>
        <Trans i18nKey={titleTrans}>{title}</Trans>
      </span>
      <Button variant="link" disabled={loading} onClick={clickEvent}>
        <Trans i18nKey={buttonTrans}>{buttonText}</Trans>
      </Button>
    </ActionRow>
  );
};

const ActionRow = styled.div`
  padding: 10px 20px;
  flex-grow: 1;
  display: flex;
  flex-flow: column;
  gap: 5px;
  > span {
    font-size: 0.9em;
  }
  > button {
    text-align: left;
    font-size: 1.25em;
  }
`;
